// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8147) return "static/chunks/8147-516db34d59fa266d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2536":"6314049d5daaff4f","4868":"524977136b9248ad"}[chunkId] + ".js";
};